import React from "react";
import { Box, Card, Typography, CircularProgress } from "@mui/joy";

interface ProfileStatsProps {
  stats: {
    countriesCount: number;
    tripsCount: number;
    spotsCount: number;
    friendsCount: number;
  } | null;
  loading: boolean;
  onFriendsClick?: () => void;
}

const StatCard = ({
  value,
  label,
  color,
  onClick,
}: {
  value: number;
  label: string;
  color: string;
  onClick?: () => void;
}) => (
  <Card
    variant="outlined"
    sx={{
      borderColor: color,
      borderWidth: 2,
      textAlign: "left",
      padding: 2,
      ...(onClick && {
        cursor: "pointer",
        "&:hover": { opacity: 0.8 },
      }),
    }}
    onClick={onClick}
  >
    <Typography level="h2" sx={{ color }}>
      {value}
    </Typography>
    <Typography level="body-sm" sx={{ textTransform: "uppercase" }}>
      {label}
    </Typography>
  </Card>
);

export const ProfileStats = ({ stats, loading, onFriendsClick }: ProfileStatsProps) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" padding={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 2,
      }}
    >
      <StatCard
        value={stats?.countriesCount || 0}
        label="Countries"
        color="#E91E63"
      />
      <StatCard
        value={stats?.tripsCount || 0}
        label="Trips"
        color="#2196F3"
      />
      <StatCard
        value={stats?.spotsCount || 0}
        label="Spots"
        color="#FF9800"
      />
      <StatCard
        value={stats?.friendsCount || 0}
        label="Friends"
        color="#4CAF50"
        onClick={onFriendsClick}
      />
    </Box>
  );
};
